module.exports = __webpack_public_path__ + "static/9-d564a3893a1a532602d2cf454e0eaefd.png";